import { ResponsivePie } from '@nivo/pie';
import { Colors } from '@whoop/web-components';
import { formatValue } from './pieChartUtils';
import GetInnerLayer from './getInnerLayer';

type PieChartProps = {
  pieValue: number;
  color: string;
  displayVal: string;
  groupsPage?: boolean;
};

// Pie value is the number out of 100 that colors in the pie chart
// Display val is the number that is printed in the inner layer of the pie chart

function PieChart({
  pieValue, color, displayVal, groupsPage = false,
}: PieChartProps) {
  const pieData = formatValue(pieValue, displayVal);

  return (
    <ResponsivePie
      data={pieData}
      innerRadius={0.88}
      enableArcLabels={false}
      enableArcLinkLabels={false}
      isInteractive={false}
      colors={[color, groupsPage ? Colors.whiteAlpha100 : Colors.gray300]}
      layers={['arcs', 'arcLabels', 'arcLinkLabels', 'legends', GetInnerLayer]}
    />
  );
}

export default PieChart;
